import CryptoJS from "crypto-js";

export default {
  DenseString:'thanks,pig4cloud',
  init:function(){

  },
  /**
   * @description: Base64 加密
   * @param {*} textString  元数据
   * @return {*} 加密后数据
   * @author: wangxiaoheng
   */
  encryptionBase64:function(textString){
    let words = CryptoJS.enc.Utf8.parse(textString)
    return CryptoJS.enc.Base64.stringify(words)
  },
  /**
   * @description: Base64 解密
   * @param {*} wordArray  元数据
   * @return {*} 加密后数据
   * @author: wangxiaoheng
   */
  decipheringBase64:function(wordArray){
    let textString = CryptoJS.enc.Base64.parse(wordArray)
    return CryptoJS.enc.Base64.parse(textString).toString(CryptoJS.enc.Utf8)
  },
  /**
   * @description: md5加密
   * @param {*} word
   * @return {*}
   * @author: wangxiaoheng
   */
  encryptionMD5:function(word){
    return CryptoJS.MD5(word).toString();
  },
  /**
   * @description: 对称加密
   * @param {*} wordArray
   * @return {*}
   * @author: wangxiaoheng
   */
  encryptionSymmetry:function(wordArray,DenseString){
    let key = CryptoJS.enc.Latin1.parse(DenseString||'thanks,pig4cloud');
    let iv = key;
    // 加密
    let encrypted = CryptoJS.AES.encrypt(
      wordArray,
      key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
      })
    return encrypted.toString()
  },
  /**
   * @description: 对称解密
   * @param {*} secretKey
   * @return {*}
   * @author: wangxiaoheng
   */
  decipheringSymmetry:function(secretKey,DenseString){
    let key = CryptoJS.enc.Latin1.parse(DenseString||'thanks,pig4cloud');
    let iv = key;
    return CryptoJS.AES.decrypt(
      secretKey, 
      key, 
      {
        iv: iv, 
        mode: CryptoJS.mode.CBC, 
        padding: CryptoJS.pad.ZeroPadding 
      }
    )
  },

}